// v16.99 — Static CDN prefix cho asset trong /public (branding, images,
// home-assets). PUBLIC_URL chỉ set trong .env.production (build PROD) →
// preview/dev trả nguyên path gốc, PROD trả URL DO Spaces CDN.
const BASE = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

export const asset = (p) =>
  BASE && typeof p === "string" && p.startsWith("/") ? `${BASE}${p}` : p;
